import { DiscountTagFilled } from '@ori-ui/icons';
import { Link, Typography, styled } from '@ori-ui/mui';

export const Root = styled('li')(({ theme }) => ({
  padding: theme.spacing(3, 0),
  position: 'relative',
  boxSizing: 'border-box',
  margin: theme.spacing(0, 3),
  '& + li': {
    borderTop: `2px solid ${theme.palette.grey[100]}`,
  },
}));

export const StyledMiniBagWrapper = styled('div')({
  display: 'flex',
  color: '#999',
  textDecoration: 'none',
});

export const ImgLink = styled('a')(({ theme }) => ({
  padding: theme.spacing(3, 0),
  marginRight: theme.spacing(2),
  borderRadius: 5,
  position: 'relative',
  overflow: 'hidden',
}));

export const StyledItemDescription = styled('div')({
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'column',
  textDecoration: 'none',
  maxWidth: 'calc(100% - 90px)',
});

export const StyledItemInfoLink = styled(Link)(({ theme }) => ({
  display: 'flex',
  textDecoration: 'none',
  maxHeight: 40,
  overflow: 'hidden',
}));

export const StyledName = styled(Typography)({
  maxWidth: 'calc(100% - 38px)',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
});

export const Discount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  flexShrink: 0,
  width: 25,
  height: 25,
  marginLeft: 'auto',
  border: '0',
  color: theme.palette.offer.contrastText,
  borderRadius: '50%',
  backgroundColor: theme.palette.offer.main,
}));

export const DiscountIcon = styled(DiscountTagFilled)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(15),
}));

export const StyledItemDetails = styled('div')({
  display: 'flex',
  marginTop: 'auto',
  textDecoration: 'none',
});

export const StyledQuantityBlock = styled(Typography)({
  marginRight: 'auto',
  alignSelf: 'flex-end',
});

export const StyledPriceBlock = styled('div')({
  marginLeft: 'auto',
  marginTop: 'auto',
});

export const StyledPrice = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  color: theme.palette.text.secondary,
  whiteSpace: 'nowrap',
}));

export const StyledPriceOld = styled(Typography)(({ theme }) => ({
  textAlign: 'right',
  textDecoration: 'line-through',
  fontSize: theme.typography.pxToRem(12),
  color: theme.palette.text.disabled,
}));

export const ItemShadeWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
}));
